import React from "react"
// MUI
import {Box, Button, Dialog, DialogActions, DialogContent, Typography} from "@mui/material"
import {AutoAwesomeRounded} from "@mui/icons-material"
// Translation
import {useTranslation} from "react-i18next"
// Tokens
import {packagingTokens as tk} from "@/theme/packagingTokens"

type TourWelcomeDialogProps = {
    open: boolean
    // Start the guided tour (first step shows right after).
    onStart: () => void
    // Decline — the caller decides whether that also marks the tour as seen.
    onClose: () => void
}

// Small opt-in gate shown before the guided tour's first step — whether the
// tour was launched manually (top bar button) or automatically (first visit /
// v3 launch window). Nobody gets dropped into a tour without asking.
export default function TourWelcomeDialog({open, onStart, onClose}: TourWelcomeDialogProps) {

    const {t} = useTranslation(["common"])

    return (
        <Dialog open={open} onClose={onClose} maxWidth={"xs"} fullWidth>
            <DialogContent sx={{textAlign: "center", pt: 4, pb: 1}}>
                <Box
                    sx={{
                        width: 52, height: 52, mx: "auto", mb: 2,
                        borderRadius: "50%",
                        backgroundColor: tk.color.green100, color: tk.color.greenDark,
                        display: "flex", alignItems: "center", justifyContent: "center",
                    }}
                >
                    <AutoAwesomeRounded sx={{fontSize: 26}} />
                </Box>
                {/* Accent tagline above the title — the "why now" of the tour. */}
                <Typography sx={{fontSize: "11.5px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: tk.color.greenDark, mb: 0.5}}>
                    {t("tour_welcome_tagline")}
                </Typography>
                <Typography sx={{fontSize: "18px", fontWeight: 600, color: tk.color.textPrimary, mb: 1}}>
                    {t("tour_welcome_title")}
                </Typography>
                <Typography sx={{fontSize: "13.5px", color: tk.color.textSecondary}}>
                    {t("tour_welcome_dialog_body")}
                </Typography>
            </DialogContent>
            <DialogActions sx={{flexDirection: "column", gap: 1, px: 3, pb: 3, pt: 2}}>
                <Button
                    fullWidth
                    variant={"contained"}
                    disableElevation
                    onClick={onStart}
                    sx={{textTransform: "none", fontSize: "13.5px", fontWeight: 600, borderRadius: tk.radius.sm}}
                >
                    {t("tour_welcome_start")}
                </Button>
                <Button
                    fullWidth
                    onClick={onClose}
                    sx={{textTransform: "none", fontSize: "13px", fontWeight: 500, color: tk.color.textSecondary, ml: "0 !important"}}
                >
                    {t("tour_welcome_later")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
